import { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Logo from '../Asset/image/tamara_logo.png';
import Money from '../Asset/image/token_active.png';
import CustomImage from './CustomImage';
import { createBrowserHistory } from 'history';
import { useNavigate } from 'react-router-dom';
import { subscriptionPlanDetils } from '../services/userService';
import Loader from './Loader';
import { useAuth } from '../Context/AuthProvider';
import { toast } from 'react-toastify';
const history = createBrowserHistory()
function SubscriptionModal({ show, setShow }) {
    const { user } = useAuth()
    const [selectedProduct, setSelectedProduct] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        getSubscriptionDetils();
    }, [])
    const getSubscriptionDetils = async () => {
        try {
            const response = await subscriptionPlanDetils();
            if (response?.data) {
                setSelectedProduct(response?.data)
            }
        } catch (error) {
            console.log('error', error);
        }
    };
    const renderLoader = () => {
        return (
            <Loader
                visible={false}
                emptyTextKey={'EmptyHistory'}
                style={{ top: 0, position: "relative", color: "white" }} />
        )
    }
    const handleClose = () => setShow(false);
    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header className='border-0' closeButton>
                    <Modal.Title style={{ paddingLeft: "30%" }}>Buy Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBody mb-4">
                    <div className="d-flex justify-content-center align-items-center">
                        <CustomImage className="App-logo ps-2" src={Logo} />
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-2">
                        <p className='text-label'>Monthly Subscription Plans</p>
                    </div>
                    <div className="d-flex justify-content-center align-items-space-between">
                        {!selectedProduct.length ? renderLoader() : selectedProduct.map((item, index) => {
                            return (
                                <Card className="subscriptionStyle mx-2" key={index} onClick={() => {
                                    if ((user.packType == 1 && item.price == 2.99) || (user.packType == 2 && item.price == 5.99))
                                        toast.error("Already subscribed to this plan.")
                                    else
                                        navigate('/app/checkout', { state: item })

                                }}>
                                    <Card.Body>

                                        <Card.Title className="commentHeight">
                                            <p className='text-label'>${item.price}/month</p></Card.Title>
                                        <Card.Text className="sub-header">
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Card.Img variant="top" className="cardIcon" src={Money} />
                                                <p className='cardText m-2 '> {item.name}</p>
                                            </div>
                                            <p className='cardText d-flex justify-content-center align-items-center mt-2 '>{item.unlimited_access == "yes" ? "Unlimited Access" : "1 Request/hour"} </p>

                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            )
                        })}

                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
}

export default SubscriptionModal;